import {useMemo} from 'react';
import type {DataLoadStatus} from 'api/types';
import type {
  DeletePrizeFunc,
  Prize,
  SavePrizeFunc,
} from 'services/prizes/types';
import {usePrize} from 'services/prizes';
import type {NewPrizeParam, PrizeIdParam} from '../types';

export const useNewOrExistingPrize = ({
  prizeId,
  suggestion,
}: NewPrizeParam | PrizeIdParam):
  | {
      /** Loaded prize, with limit works data */
      prize: DataLoadStatus<Prize>;
      suggestion?: undefined;
      savePrize: SavePrizeFunc;
      deletePrize: DeletePrizeFunc;
    }
  | {
      prize?: undefined;
      suggestion: string;
      savePrize: SavePrizeFunc;
      deletePrize: DeletePrizeFunc;
    } => {
  const {prize: existingPrize, savePrize, deletePrize} = usePrize(prizeId);

  return useMemo(() => {
    if (prizeId) {
      return {prize: existingPrize, savePrize, deletePrize};
    }

    return {
      suggestion: suggestion ?? '',
      savePrize,
      deletePrize,
    };
  }, [prizeId, deletePrize, existingPrize, savePrize, suggestion]);
};
